const initialState: any = {
  started: false,
  onboarding_viewed: false,
  personal_form: {
    first_name: null,
    last_name: null,
    phone: null,
    email: null,
    patient_age_range: null,
    anti_depressant_prescription: null,
    non_drug_treatment: null,
  },
  form: {
    tired_no_reason: null,
    felt_nervous: null,
    hopeless: null,
    nervous_uncontrollable: null,
    restless_fidgety: null,
    restless_cant_sit_still: null,
    felt_depressed: null,
    everything_effort: null,
    sad_nothing_helps: null,
    felt_worthless: null,
  },
  suicide_attempt: null,
  suicide_attempt_when: null,
  prior_treatment: null,
};

export { initialState };